module.exports = __webpack_public_path__ + "img/member_3.7728e509.jpg";